var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"height":"calc(100vh - 142px)"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none","display":"block"},attrs:{"src":_vm.docsUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }